import {useId,View,PopupView,isTouchDevice,map} from "vritra";
import css from "./Preview.module.css";


export default function Preview(props){
    const {parent,id=useId("preview")}=props;
    const preview=View({parent,id,className:css.preview});

    preview.innateHTML=`
        ${map((window.innerWidth<567)?12:20,()=>`
            <p class="button ${css.item}">click me</p>
        `)}
    `;

    const itemEls=preview.querySelectorAll(`.${css.item}`);
    itemEls.forEach(itemEl=>{
        itemEl.onclick=()=>{
            PopupView({
                parent:preview,
                target:itemEl,
                className:css.popupview,
            }).innateHTML=`
                <p>I'm a PopupView</p>
                <p>I'm adjusting my position to stay in the box</p>
            `;
        }
    });
    preview.oncontextmenu=(event)=>{
        event.preventDefault();
    }
    

    return preview;
}
